import getters from './getters'
import actions from './actions'
import state from './state'

const defaultFilters = {
    brands: [],
    brand_model: [],
    fuel_type: [],
    argerd: [1999, 2021],
    verd: [0, 20000000],
    ekinn: [0, 287000],
    girartegund: [],
    flokkar: [],
    other: [],
    vt: [],
    verdtilbod: false,
    category: [],
    sort: {
        field: "",
        order: ""
    },
    parking: false,
    companies: []
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations: {
        RESET_CARS(state) {
            state.cars.scrollTop = 0
            state.cars.filters = defaultFilters,
                state.cars.items = []
            state.cars.loaded = false
        }
    }
}